'use client';

import type React from 'react';
import { Suspense, useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import type { RealEstateCatalogResponseT } from '@/forApp/types/Entity';
import CatalogFilters from '@/widgets/Catalog/CatalogFilters/CatalogFilters';
import CatalogListMap from '@/widgets/Catalog/CatalogList/CatalogListMap';
import CatalogMapSkeleton from '@/widgets/CatalogMap/CatalogMapSkeleton/CatalogMapSkeleton';
import type { DefaultFilterT } from '@/widgets/MainBlock/MainSearch/types';
import { getRouteHref, ROUTES } from '@/forApp/utils/routes';

import styles from '@/app/maps/[type]/styles.module.css';

export type CatalogForMapProps = {
  type: string;
  error: string | null;
  mainFilters: DefaultFilterT | null;
  catalog: RealEstateCatalogResponseT | null;
  filtersOpen: boolean;
  isMobile: boolean;
};

const CatalogForMap: React.FC<CatalogForMapProps> = ({
  type,
  error,
  mainFilters,
  catalog,
  filtersOpen,
  isMobile,
}) => {
  const [load, setLoad] = useState(false);
  const pathname = usePathname();
  useEffect(() => {
    setLoad(false);
  }, []);
  return (
    <div
      className={!isMobile ? styles.leftContent : styles.leftContentMobile}
      style={filtersOpen ? { paddingLeft: '32px', paddingRight: '32px' } : {}}
    >
      <Suspense fallback={<CatalogMapSkeleton />}>
        {error ? (
          <div>Произошла ошибка: {error}</div>
        ) : !mainFilters || !catalog || load ? (
          <CatalogMapSkeleton />
        ) : filtersOpen ? (
          <CatalogFilters
            type={type}
            filters={mainFilters}
            setLoad={setLoad}
            isMobile={isMobile}
            isMaps
          />
        ) : (
          <CatalogListMap
            catalogList={catalog.entities.data}
            typeObj={catalog.slug}
            currentPage={catalog.entities.meta.current_page}
            totalItems={catalog.entities.meta.total}
            itemsPerPage={catalog.entities.meta.per_page}
            basePath={
              pathname || getRouteHref(ROUTES.MAP, { type: catalog.slug })
            }
            isMobile={isMobile}
          />
        )}
      </Suspense>
    </div>
  );
};

export default CatalogForMap;
